import React, { useEffect, useState } from "react";

import { Avatar, Divider, Grid, } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import AppDialog from "../../../components/Common/AppDialog";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import LoadingDialog from "../../../components/Common/LoadingDialog";
import Notification from "../../../components/Common/Notification";
import Table from "../../../components/Common/Table";
import Header from "../../../components/VerticalLayout/Header";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton";
import Label from "../../../components/Common/Label";
import TablePageControl from "../../../components/Common/TablePageControl";
import ImportantNotice from "../../../components/Common/ImportantNotice";
import CustomSelect from "../../../components/Form/CustomSelect";
import DeactivateModal from "../../../components/Common/DeactivateModal";
import AddUser from "./AddUser";
import { getUserDetails, resetUserActionState, resetUserState, updateActivationUser, updateDepartmentUser, updateUser } from "../../../store/actions";
import Helpers from "../../../helpers/helpers";
import moment from "moment";

const UserDetails = ({ title, userDetails, userPermission, requiredPermission, departmentList, roleList, editUser, editUserActivation, editUserDepartment, memberAuditTrail }) => {
    const { ID, type } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth); // Update state when window resizes
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize); // Cleanup on unmount
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [error, setError] = useState("");
    const [width, setWidth] = useState(window.innerWidth);
    const [editable, setEditable] = useState(true);
    const [tempCCEMail, setTempCCEmail] = useState([]);
    const [changeDepartmentOpen, setChangeDepartmentOpen] = useState(false);
    const [editOpen, setEditOpen] = useState(false);
    const [activationOpen, setActivationOpen] = useState(false);
    const [suspendOpen, setSuspendOpen] = useState(false);
    const [currentDepartment, setCurrentDepartment] = useState("");
    const [page, setPage] = useState(1);
    const [length, setLength] = useState("10");
    const [sort, setSorted] = useState("asc")
    const [sort_by, setSortBy] = useState("id")
    const [checkedAll, setCheckedAll] = useState(false);

    const [loading, setIsLoading] = useState(false);
    const [preview, setProfileImg] = useState();
    const [profileImgFile, setProfileImgFile] = useState();
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("update-user") && setEditable(true);
        }
    }, [userPermission])

    useEffect(() => {
        dispatch(resetUserState());
        return () => {
            dispatch(resetUserState());
        }
    }, [])

    useEffect(() => {
        initData();
    }, [ID])

    useEffect(() => {
        setIsLoading(true);
        // dispatch(getMemberAuditTrail({ id: ID, page: page, length: length, type: type }))
    }, [page])

    useEffect(() => {
        if(memberAuditTrail?.data){
            setIsLoading(false);
        }
    }, [memberAuditTrail])

    useEffect(() => {
        if (userDetails?.department_id) {
            setCurrentDepartment(userDetails?.department_id);
        }
    }, [userDetails])

    useEffect(() => {
        if (editUser?.code === "success") {
            setIsLoading(false);
            setEditOpen(false);
            setError("");
            setNotification({ open: true, msg: 'User has been updated successfully', type: "success" });
            dispatch(resetUserActionState());
            initData();
        } else if (editUser?.code === "invalid_field") {
            setIsLoading(false);
            setError(editUser?.errors);
            setNotification({ open: true, msg: 'Invalid field', type: "error" });
            dispatch(resetUserActionState());
        }
    }, [editUser])


    useEffect(() => {
        if (editUserActivation?.code === "success" || editUserDepartment?.code === "success") {
            setIsLoading(false);
            setEditOpen(false);
            setError("");
            activationOpen && setActivationOpen(false);
            changeDepartmentOpen && setChangeDepartmentOpen(false);
            setNotification({ open: true, msg: 'User has been updated successfully', type: "success" });
            dispatch(resetUserActionState());
            initData();
        }
    }, [editUserActivation, editUserDepartment])

    const header = [
        {
            Header: "Date",
            accessor: (cell) => {
                return (cell?.created || "-")
            },
        },
        {
            Header: "Action",
            accessor: (cell, idx) => {
                return (cell?.remark || "-")
            },
            minWidth: 200,
        },
        {
            Header: "Performed By",
            accessor: (cell, idx) => {
                return (cell?.ref || "-")
            },
        }
    ]

    const status = type === 'admin' ? userDetails?.admin_status : userDetails?.status;

    const actionItems = [
        { iconName: 'ri-pencil-line', label: 'Edit', color: '#454545', permission: editable, onClick: () => { setEditOpen(true) } },
        { label: status === 'active' ? 'Deactivate' : 'Activate', iconName: status === 'active' ? 'ri-eye-off-line' : 'ri-eye-line', color: '#454545', permission: true, onClick: () => setActivationOpen(true) },
        { label: 'Suspend User', iconName: 'ri-forbid-line', color: '#F65151', permission: true, onClick: () => setSuspendOpen(true) },
    ]

    const memberActionItems = [
        { iconName: 'ri-pencil-line', label: 'Edit', color: '#454545', permission: editable, onClick: () => { setEditOpen(true) } },
        { label: 'Change Department', iconName: 'ri-arrow-left-right-line', color: '#454545', permission: true, onClick: () => setChangeDepartmentOpen(true) },
        { label: status === 'active' ? 'Deactivate' : 'Activate', iconName: status === 'active' ? 'ri-eye-off-line' : 'ri-eye-line', color: '#454545', permission: true, onClick: () => setActivationOpen(true) },
        { label: 'Suspend User', iconName: 'ri-forbid-line', color: '#F65151', permission: true, onClick: () => setSuspendOpen(true) },
    ]

    const initData = () => {
        dispatch(getUserDetails({ id: ID, type: type }));
    }

    const getLengthPage = (page, length) => {
        setPage(page)
        setLength(length)
    }

    const handleEditUser = async (data) => {
        setIsLoading(true);
        dispatch(updateUser({ id: ID, data: data, userType: type }));
    };

    const handleChangeActivation = () => {
        setIsLoading(true);
        dispatch(updateActivationUser({
            userType: type,
            id: ID,
            action: status === 'active' ? 'deactivate' : 'activate'
        }))
    }

    const handleChangeDepartment = () => {
        setIsLoading(true);
        dispatch(updateDepartmentUser({ id: ID, data: { department_id: currentDepartment } }));
    }

    const renderUserInfo = () => {
        const firstLetter = userDetails?.name ? userDetails?.name.charAt(0).toUpperCase() : '';

        return (
            <>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={12}>
                        <Avatar alt="User Avatar" src={userDetails?.profile_photo_path || ''} style={{ height: 88, width: 88 }}>{firstLetter}</Avatar>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="text-bold font-size-20">{userDetails?.name || "-"}</div>
                        <div className="subheader-2">{userDetails?.email || "-"}</div>
                    </Grid>
                    <Grid item container xs={12} mt={1} spacing={2}>

                        <Grid item container xs={6}>
                            <Grid item xs={4}>
                                <div className="subheader-2">Name</div>
                            </Grid>
                            <Grid item xs={8}>
                                {userDetails?.name || '-'}
                            </Grid>
                        </Grid>
                        <Grid item container xs={6}>
                            <Grid item xs={4}>
                                <div className="subheader-2">Status</div>
                            </Grid>
                            <Grid item xs={8}>
                                {status ? <Label.GeneralStatusLabel label={status} list={Helpers.memberStatus} marginLeft={"0px"} /> : '-'}
                            </Grid>
                        </Grid>
                        <Grid item container xs={6}>
                            <Grid item xs={4}>
                                <div className="subheader-2">Email</div>
                            </Grid>
                            <Grid item xs={8}>
                                <div className="">{userDetails?.email || '-'}</div>
                            </Grid>
                        </Grid>
                        <Grid item container xs={6}>
                            <Grid item xs={4}>
                                <div className="subheader-2">Role</div>
                            </Grid>
                            <Grid item xs={8}>
                                <div className="">{userDetails?.role || '-'}</div>
                            </Grid>
                        </Grid>
                        <Grid item container xs={6}>
                            <Grid item xs={4}>
                                <div className="subheader-2">Phone Number</div>
                            </Grid>
                            <Grid item xs={8}>
                                <div className="">{userDetails?.phone ? `+${userDetails.phone}` : '-'}</div>
                            </Grid>
                        </Grid>
                        {
                            type === 'member' &&
                            <>
                                <Grid item container xs={6}>
                                    <Grid item xs={4}>
                                        <div className="subheader-2">Department</div>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <div className="">{userDetails?.depart || '-'}</div>
                                    </Grid>
                                </Grid>
                                <Grid item container xs={6}>
                                    <Grid item xs={4}>
                                        <div className="subheader-2">IC Number</div>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <div className="">{userDetails?.identity_number || '-'}</div>
                                    </Grid>
                                </Grid>
                                <Grid item container xs={6}>
                                    <Grid item xs={4}>
                                        <div className="subheader-2">Team</div>
                                    </Grid>
                                    <Grid item xs={8}>
                                        <div className="">{userDetails?.team_name || '-'}</div>
                                    </Grid>
                                </Grid>
                                <Grid item container xs={6}></Grid>
                            </>
                        }
                        <Grid item container xs={6}>
                            <Grid item xs={4}>
                                <div className="subheader-2">Created Since</div>
                            </Grid>
                            <Grid item xs={8}>
                                <div className="">{userDetails?.created_at ? moment(userDetails?.created_at).format("DD MMM YYYY") : '-'}</div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !userDetails?.id} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Header
                        breadcrumb={<Breadcrumbs
                            breadcrumbItems={[{ title: "Settings", link: "/settings" },
                            { title: title, link: "/settings-users" },
                            { title: userDetails?.name || '-', link: "#" },
                            ]}
                            showBackButton={true}
                        >
                        </Breadcrumbs>}

                        children={
                            <RenderPopOverButton
                                items={type === 'admin' ? actionItems : memberActionItems}
                                bordered={true}
                            />
                        } />
                    {renderUserInfo()}
                    <Divider style={{ marginBlock: 30 }} />
                    <div className="text-bold font-size-16 mb-2">Audit Trail</div>
                    <Table
                        header={header}
                        data={memberAuditTrail?.data || []}
                        pageSize={length}
                        totalPage={memberAuditTrail?.last_page}
                        getLengthPage={getLengthPage}
                        customToolsBar={true}
                        setCheckedAll={setCheckedAll}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        checkedAll={checkedAll}
                        sort={sort}
                    />
                    <TablePageControl
                        from={memberAuditTrail?.from || 0}
                        to={memberAuditTrail?.to || 0}
                        total={memberAuditTrail?.total || 0}
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={memberAuditTrail?.last_page || 1}
                    />
                </Container>
                <AddUser
                    open={editOpen}
                    close={() => { setEditOpen(false); error && setError(''); }}
                    submit={(data) => handleEditUser(data)}
                    userDetails={userDetails}
                    type={"edit"}
                    userType={type}
                    roleList={roleList}
                    departmentList={departmentList}
                    error={error}
                />
                <AppDialog
                    open={suspendOpen}
                    close={() => setSuspendOpen(false)}
                    title={"Suspend User"}
                    cancelButton={true}
                    positiveTitle={'Suspend'}
                    positivePress={() => ''}
                    positiveButtonStyle={{ backgroundColor: '#F65151', border: '1px solid #F65151' }}
                    width={'40%'}
                >
                    You are about to temporarily suspend this user’s access and their associated orders, quotations, and tasks.
                    <ImportantNotice
                        message={'Once suspended, this user will not be able to log in, and their active orders will be paused until reactivation.'}
                        color={'#DBBD8799'}
                        backgroundColor={'#FFCD7133'}
                        iconColor={'#DBBD87'}
                    />
                    <div className="mt-2">Do you still want to proceed?</div>
                </AppDialog>
                <AppDialog
                    open={changeDepartmentOpen}
                    close={() => setChangeDepartmentOpen(false)}
                    title={"Change department"}
                    cancelButton={true}
                    positiveTitle={'Save'}
                    positivePress={() => handleChangeDepartment()}
                    width={'40%'}
                >
                    <CustomSelect
                        title={"Department"}
                        placeholder={"Select one"}
                        values={currentDepartment}
                        onChange={(e) => setCurrentDepartment(e)}
                        data={departmentList || []}
                        labelName={"name"}
                        valueName={"id"}
                    />
                </AppDialog>
                <DeactivateModal
                    open={activationOpen}
                    title={status === 'active' ? "Deactivate" : "Activate"}
                    message={status === 'active' ?
                        <div>
                            <div>Once deactivated, the user will permanently lose access to the system until reactivated.</div>
                            <div>All related records (orders, quotations, and tasks) will remain stored, but no new actions can be performed by this user.</div>
                        </div> : ""}
                    close={() => { setActivationOpen(false) }}
                    submit={() => handleChangeActivation()}
                    module={'user'}
                />
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ User, General, Login, Member }) {
    return {
        errors: User?.error,
        editUser: User.editUser,
        userDetails: User?.userDetails,
        userData: Login?.verifyAdmin?.user?.data,
        editUserActivation: User.editUserActivation,
        editUserDepartment: User.editUserDepartment,
        memberAuditTrail: Member.memberAuditTrail,
        userPermission: Login?.permissionArry,
        departmentList: General?.department_list,
        roleList: General?.role_list,
    };
}


export default connect(mapStateToProps)(UserDetails);
